import { createTheme } from "@mui/material/styles";
import { nuetral, primary, secondary } from "./colors";

const theme = createTheme({
  palette: {
    primary: {
      main: primary[500],
      light: primary[300],
      dark: primary[700],
      ...primary,
    },
    secondary: {
      main: secondary[500],
      light: secondary[300],
      dark: secondary[700],
      ...secondary,
    },
    nuetral: {
      main: nuetral[500],
      light: nuetral[300],
      dark: nuetral[700],
      ...nuetral,
    },
  },
});

export default theme;
